import { FlightDeal } from '@shared/types';

/**
 * Function that filters flights by restricted destinations
 * @param {FlightDeal[]} destinations Array of Destinations
 * @param {string} restrictedDestinations string of destinations with restrictions, eg: "ROC,BGI"
 * @param {number} maxDisplayed max number of items included in the filter
 * @returns {FlightDeal[]} returns filtered flights that matches with restrictedDestinations.
 */
export const filterDealsByRestrictDestinations = (
  destinations: FlightDeal[],
  restrictedDestinations: string,
  maxDisplayed: number,
): FlightDeal[] => {
  const allowedDestinations = new Set(restrictedDestinations.split(','));
  return destinations
    .filter(flightDeal =>
      allowedDestinations.has(flightDeal.destinationAirportCode),
    )
    .slice(0, maxDisplayed);
};
